import { Button } from '../ui/button'
// @ts-strict-ignore
import { Icon } from '@blueprintjs/core'
import { Menu, MenuItem } from '../ui/menu'
import { MyHTMLTable } from '../../packages/blueprint-components/src/HTMLTable'
import { MinimalStateDot } from '../badge/MinimalStateDot'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import React, { Fragment } from 'react'
import PromotionItemI = Models.PromotionItemI
import { EllipsisMenu } from '../../icons/icons'
import { groupItems } from '../../util/promotions'
import { Column } from '../../types/table'

interface PromotionItemsTableDummyProps {
    setShowAdd: any // @todo type
    screenshotMode: boolean
    removeItem: any // @todo type
    items: PromotionItemI[]
    disableAddItems?: boolean
    disableRemoveItems?: boolean
}

export const PromotionItemsTableDummy = ({
    setShowAdd,
    screenshotMode,
    removeItem,
    items,
    disableAddItems,
    disableRemoveItems,
}: PromotionItemsTableDummyProps) => {
    const columns: Column<PromotionItemI, {}>[] = [
        {
            key: 'campaign',
            title: (
                <div>
                    Campaign
                    <br />
                    Ad Group
                </div>
            ),
            cell: (row) => (
                <div>
                    <MinimalStateDot state={row.campaign_state} />
                    <Link
                        to={`/campaigns/${row.campaign_id}`}
                        className={classNames({ blur: screenshotMode })}
                    >
                        {row.campaign_name}
                    </Link>
                    <br />
                    <MinimalStateDot state={row.ad_group_state} />
                    <Link
                        to={`/ad-groups/${row.ad_group_id}`}
                        className={classNames({ blur: screenshotMode })}
                    >
                        {row.ad_group_name}
                    </Link>
                </div>
            ),
        },
        {
            key: ' ',
            cell: (row) =>
                disableRemoveItems ? null : (
                    <EllipsisMenu
                        content={
                            <Menu>
                                <MenuItem text="Remove Item" onClick={() => removeItem(row)} />
                            </Menu>
                        }
                    />
                ),
        },
    ]
    return (
        <Fragment>
            <div className="px-4 pt-4 flex justify-between items-center">
                <div className="font-normal text-lg">Linked Ad Groups</div>
                {!disableAddItems && (
                    <Button
                        className="rounded-lg"
                        text="Link Ad Group"
                        minimal
                        outlined
                        icon={<Icon icon="plus" color="#3391FF" />}
                        onClick={() => setShowAdd(true)}
                    />
                )}
            </div>
            <MyHTMLTable
                disableDefaultHtmlTableWrapperStyle={false}
                htmlTableWrapperClassname={'table-full-page-height'}
                className="mj-table"
                paginationClassname="mx-4 mb-4"
                columns={columns}
                items={groupItems(items)}
                canSelect={false}
                onSelectChange={null}
                selectKey={null}
                stickyHeader
                stickyFooter
            />
        </Fragment>
    )
}
